module.exports = __webpack_public_path__ + "static/media/windchill-icon.669b40bd.svg";